<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: {
    dataNotComplete: Object,
    listDate: Array,
    ///listDesigner:Array,
  },
  data: () => ({
    dataSetNotComplete: [
      {
        backgroundColor: [],
        data: [],
      },
    ],
    listStatus: ["New", "Assigned", "Processing", "Need Review"],
  }),
  methods: {
    //Designer
    loadDataSetNotComplete() {
      for (const i of this.listStatus) {
        var sum = 0;
        for (const j in this.dataNotComplete) {
          sum += this.dataNotComplete[j][i];
        }
        this.dataSetNotComplete[0].data.push(sum);
      }

      for (const k of this.listStatus) {
        if (k == "New") {
          this.dataSetNotComplete[0].backgroundColor.push("#ef5350");
        } else if (k == "Assigned") {
          this.dataSetNotComplete[0].backgroundColor.push("#FFEB3B");
        } else if (k == "Processing") {
          this.dataSetNotComplete[0].backgroundColor.push("#42A5F5");
        } else if (k == "Need Review") {
          this.dataSetNotComplete[0].backgroundColor.push("#AB47BC");
        }
      }
      console.log("dataSetNotComplete: ", this.dataSetNotComplete);

      this.renderChart(
        {
          labels: this.listStatus,
          datasets: this.dataSetNotComplete,
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: "bottom" },
          title: {
            display: true,
            text: "Task Not Completed (VN Timezone)",
          },
          tooltips: {
            mode: "index",
            intersect: false,
            position: "nearest",
          },
        }
      );
    },
  },
  async mounted() {
    await this.loadDataSetNotComplete();
  },
};
</script>